<form [formGroup]="form" class="g-slider-container">
    <app-notification [type]="toasterType.Info">
        {{ otAgentsTexts.generate_api_key.slider.info }}
    </app-notification>

    <div class="g-field-area">
        <label for="icp">{{ otAgentsTexts.generate_api_key.slider.icp_ip }}</label>
        <input id="icp"
               class="g-large-field"
               [formControl]="icpAddress"
        />
        <app-validation-message [messageText]="errorTexts.empty_ip"
                                [validation]="formValidatorsService.isEmpty(icpAddress)"
        ></app-validation-message>
        <app-validation-message [messageText]="errorTexts.invalid_hostname"
                                [validation]="formValidatorsService.isBadPattern(icpAddress)"></app-validation-message>
        <app-validation-message [messageText]="errorTexts.invalid_ip"
                                [validation]="formValidatorsService.isInvalidIp(icpAddress)"></app-validation-message>
    </div>

    <div class="g-field-area">
        <label for="expiryTimeInput" class="g-mandatory">{{ otAgentsTexts.generate_api_key.slider.expiration_period }}</label>

        <div>
            <input
                    type="number"
                    min="1" max="365"
                    id="expiryTimeInput"
                    class="g-extra-small-field"
                    formControlName="expiryTime"/>

            <label for="expiryTimeInput">
                {{ otAgentsTexts.generate_api_key.slider.days }}
            </label>
        </div>
        <app-validation-message [messageText]="errorTexts.empty_expiration"
                                [validation]="formValidatorsService.isEmpty(expiryTime)"></app-validation-message>
    </div>

    <div class="g-field-area">
        <label for="keyDescriptionInput" class="g-mandatory"> {{ otAgentsTexts.generate_api_key.slider.description }}</label>

        <textarea formControlName="description" maxlength="250" id="keyDescriptionInput"></textarea>
        <app-validation-message [messageText]="errorTexts.empty_description"
                                [validation]="formValidatorsService.isEmpty(description)"></app-validation-message>
    </div>
</form>
